import { render, staticRenderFns } from "./RegistrarSelect.vue?vue&type=template&id=85e62386&"
import script from "./RegistrarSelect.vue?vue&type=script&lang=js&"
export * from "./RegistrarSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem})
